import { Navigate, useParams } from "react-router";
import { lazyWithRetry } from "@/shared/utils/lazyWithRetry";

const FolderDetailPage = lazyWithRetry(() => import("@/features/fileManager/pages/FolderDetailPage"));

export const FolderDetailRoute = () => {
  const { id } = useParams<{ id: string }>();

  // Legacy document genre IDs are numeric; modern folders use prefixed IDs.
  if (id && /^\d+$/.test(id)) {
    return <Navigate to="/fichiers" replace />;
  }

  return <FolderDetailPage />;
};
